import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { JobProcedureSummaryReview } from '../models/job-procedure-summary-review.model';
import { JobProcedureService } from '../services/sections/job/job-procedure.service';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

@Injectable({
  providedIn: 'root'
})
export class ProcedureSummaryReviewResolver implements Resolve<JobProcedureSummaryReview> {
    constructor(
      private router: Router,
      private procedureService: JobProcedureService
    ) {}
    resolve(route: ActivatedRouteSnapshot): Observable<JobProcedureSummaryReview> {
      GlobalSettingsService.isSecondaryLoaderLoading = true;

    const token = route.paramMap.get('token');
    if (!token) {
        GlobalSettingsService.isSecondaryLoaderLoading = false;
        this.router.navigate(['/404']);
        return NEVER;
      }

      return this.procedureService
      .getProcedureSummaryReviewDetails(token)
      .pipe(
        catchError(() => {
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          this.router.navigate(['/404']);
          return NEVER;
        })
      );
    }
}
